/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, Fragment, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import { EnableSidebar } from '../../../../_metronic/layout/core'
import { PDFCard } from '../../../../_metronic/partials/content/cards/PDFCard'
import { Link } from 'react-router-dom'

const articles = [
    {
        title: `หัวข้อวิทยานิพนธ์`,
        th_text: `“หญิงชั่ว” ในประวัติศาสตร์ไทย: การสร้างความเป็นหญิงโดยชนชั้นนำสยามช่วงต้นรัตนโกสินทร์ - พ.ศ. 2477`,
        en_text: `"HARLOTS" IN THAI HISTORY: A CONSTRUCTION OF FEMININITY BY THE SIAMESE ELITE, EARLY BANGKOK PERIOD - 1934`
    },
    {
        title: `รายละเอียด`,
        th_text: `วิทยานิพนธ์นี้เป็นส่วนหนึ่งของการศึกษา ตามหลักสูตรศิลปศาสตร์มหาบัณฑิต สาขาวิชาประวัติศาสตร์ คณะศิลปศาสตร์ , มหาวิทยาลัย ธรรมศาสตร์ ปีการศึกษา 2559`,
        en_text: ''
    },
    {
        title: `หมายเลขอ้างอิง`,
        th_text: `TT0060`,
        en_text: ''
    },
    {
        title: `ชื่อผู้เขียน`,
        th_text: `นางวรธิภา สัตยานุศักดิ์กุล`,
        en_text: `MRS. WORATHIPA SATAYANUSAKKUL`
    },
    {
        title: `อาจารย์ที่ปรึกษาวิทยานิพนธ์`,
        th_text: `ดร. ปรีดี หงษ์สต้น`,
        en_text: ''
    },
    {
        title: `บทคัดย่อ`,
        th_text: `วิทยานิพนธ์นี้มุ่งศึกษากระบวนการสร้างและการนำเสนอ “หญิงชั่ว” ในประวัติศาสตร์ ไทย โดยศึกษาประวัติและภาพลักษณ์ของผู้หญิงที่ถูกตีตราและเข้าข่ายชั่วในหลักฐานทาง ประวัติศาสตร์ บริบททางสังคมและวัฒนธรรมในแต่ละยุคสมัยเป็นตัวกำหนดพฤติกรรมความชั่วและ เป็นตัวกำกับการสร้างความดีความชั่วให้แก่ผู้หญิง ผ่านการถ่ายทอดความรู้ สำนึก ค่านิยมและจารีต ทางสังคม ผลการศึกษาพบว่าภาพลักษณ์ของ “หญิงชั่ว”ในประวัติศาสตร์ไทยช่วงต้นรัตนโกสินทร์ - พ.ศ. 2477 เกิดจากมโนทัศน์และค่านิยมของผู้ชาย ในสมัยต้นรัตนโกสินทร์ “หญิงชั่ว”ถูกเสนอใน ภาพของผู้หญิงที่ละเมิดศีลธรรมทางพุทธศาสนา และในยุคถัดมาคือ สมัยรัชกาลที่ 4 – พ.ศ. 2477 “หญิงชั่ว”ถูกเสนอในภาพของผู้หญิงที่ละเมิดจารีตเดิมและต่อต้านอำนาจชายเป็นใหญ่ในสังคมสยาม การเขียนประวัติศาสตร์ของผู้ชายยังสะท้อนถึงค่านิยมบางประการที่ผู้ชายคาดหวังต่อผู้หญิงและความคาดหวังเหล่านี้ถูกแสดงออกมาในรูปแบบของการสร้างภาพลักษณ์ผู้หญิงที่ไม่เป็นที่พึงประสงค์ของผู้ชายในรูปแบบของหญิงชั่วที่หญิงดีไม่ควรเอาเยี่ยงอย่าง`,
        en_text: `THIS THESIS AIMS TO EXAMINE THE PROCESS OF CONSTRUCTION AND PRESENTATION OF “HARLOTS” IN THAI HISTORY BY EXPLORING THE STORIES AND IMAGES OF WOMEN WHO WERE LABELLED AS “BAD” IN HISTORICAL SOURCES. IT SHOWS THAT THE SOCIAL AND CULTURAL CONTEXTS IN EACH HISTORICAL PERIOD PLAYED A ROLE IN SHAPING AND DIRECTING GOOD AND BAD BEHAVIORS FOR WOMEN THROUGH THE DISSEMINATION OF SOCIAL KNOWLEDGE, CONSCIOUSNESS, VALUE AND TRADITION. THE THESIS ARGUES THAT THE IMAGE OF “HARLOTS”IN THAI HISTORY FROM THE EARLY BANGKOK PERIOD TO 1934 WERE IMPOSED BY MEN’S STANDARDS AND VALUES. IN THE EARLY BANGKOK PERIOD, “HARLOTS” WERE PRESENTED AS IMMORAL WOMEN. IN THE NEXT PERIOD, THE REIGN OF KING RAMA IV- 1934, “HARLOTS” WERE PRESENTED AS THE WOMEN WHO ACTED AGAINST THE OLD TRADITIONAL WAYS AND THE WOMEN WHO DENIED MEN'S AUTHORITY. FURTHERMORE, HISTORICAL WRITINGS BY MEN ALSO REFLECTED SOME EXPECTED VALUES, AND THESE EXPECTATIONS WERE SHOWN IN THE FORM OF THE CONSTRUCTION OF “UNACCEPTABLE” FEMALE BEHAVIORS THAT DECENT WOMEN SHOULD NOT FOLLOW.`
    },
    {
        title: `ปีที่เผยแพร่`,
        th_text: `2560 / 2017`,
        en_text: ''
    },
    {
        title: `ระดับการศึกษา`,
        th_text: `ปริญญาโท`,
        en_text: ``,
    },
    {
        title: `ชื่อปริญญา`,
        th_text: `ศิลปศาสตรบัณฑิต (ศศ.บ.)`,
        en_text: ``,
    },
    {
        title: `สาขาวิชา`,
        th_text: `ประวัติศาสตร์`,
        en_text: ``,
    },
    {
        title: `ปีการศึกษา`,
        th_text: `2559 / 2016`,
        en_text: ``,
    },
    {
        title: `คำสำคัญ`,
        th_text: `หญิงชั่ว, การสร้างความเป็นหญิง, ชนชั้นน าสยาม`,
        en_text: `HARLOT, CONSTRUCTION OF FEMININITY, SIAMESE ELITE`
    },
    {
        title: `ตีพิมพ์`,
        th_text: `Bangkok : Thammasat University`,
        en_text: ``,
    },
]

function getHeader(header: string) {
    return <h4 className='p-2 text-gray-800 fw-bolder mt-10 bg-light-primary rounded border'>{header}</h4>
}

function getSingleBlock(header: string, text: string) {
    return <>
        <div className='fs-4 fw-normal text-gray-800 mb-10 mt-10'>
            {getHeader(header)}
            <input
                type="text"
                className="form-control"
                value={text}
            />
        </div>
    </>
}

function getDoubleBlock(header: string, th_string: string, en_string: string) {
    return <>
        {getHeader(header)}
        <div className='notice rounded border-primary border border-dashed ps-2 pe-2'>
            <div className='d-flex w-100 mt-3'>
                <div className='d-flex h-50px w-50px flex-shrink-0 flex-center position-relative'>
                    <KTSVG
                        path='/media/icons/duotune/abstract/abs051.svg'
                        className='svg-icon-primary position-absolute opacity-15'
                        svgClassName='h-40px w-40px'
                    />
                    TH
                </div>
                <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                    <input
                        type="text"
                        className="form-control"
                        value={th_string}
                    />
                </div>
            </div>

            <div className='d-flex w-100 mb-2 mt-4'>
                <div className='d-flex h-50px w-50px flex-shrink-0 flex-center position-relative'>
                    <KTSVG
                        path='/media/icons/duotune/abstract/abs051.svg'
                        className='svg-icon-primary position-absolute opacity-15'
                        svgClassName='h-40px w-40px'
                    />
                    EN
                </div>
                <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                    <input
                        type="text"
                        className="form-control"
                        value={en_string}
                    />
                </div>
            </div>
        </div>
    </>
}

const PublicationEdit: React.FC = () => {
    const [textFormatting, setTextFormatting] = useState<boolean>(false)

    return (
        <EnableSidebar>
            <div className='mb-0'>
                <div className=''>
                    <div className='d-flex align-items-center py-1'>
                        <div className='symbol symbol-35px me-2'>
                            <PDFCard icon='/media/svg/files/pdf.svg' title='view' />
                        </div>

                        <div className='w-100'>
                            <input
                                type="text"
                                className="form-control"
                                value={'“หญิงชั่ว” ในประวัติศาสตร์ไทย: การสร้างความเป็นหญิงโดยชนชั้นนำสยามช่วงต้นรัตนโกสินทร์ - พ.ศ. 2477'}
                            />
                            <span>สถานะ: รอการตรวจสอบ</span>
                        </div>
                    </div>
                </div>

                <div className='d-flex align-items-center mb-9'>
                    <div className='d-flex align-items-center'>
                        <span className='ms-1' data-bs-toggle='tooltip' title='User replied'>
                            <KTSVG
                                path='media/icons/duotune/general/gen043.svg'
                                className='svg-icon-success svg-icon-1'
                            />
                        </span>
                    </div>
                </div>

                {articles.map((a, i) => {
                    return (
                        <Fragment key={`article_${i}`}>
                            {(a.en_text) ? getDoubleBlock(a.title, a.th_text, a.en_text) : getSingleBlock(a.title, a.th_text)}
                        </Fragment>
                    )
                })}

                <div className='d-flex flex-stack flex-wrap mt-2'>
                    <div className='d-flex align-items-center py-1'>
                        <i className='bi bi-clock me-2 fs-2'></i>

                        <div className='d-flex flex-column align-items-start justify-content-center mt-1'>
                            <span className='text-gray-800 fs-7 fw-bold lh-1 mb-2'>last update</span>
                            <span className='text-muted fs-8 fw-bold lh-1'>24 minutes ago</span>
                        </div>
                    </div>

                </div>
            </div>

            <div className='separator separator-dashed border-gray-300 mt-8 mb-10'></div>

            <a href="#" className="btn btn-primary me-2">บันทึก</a>
            <a href="#" className="btn btn-secondary">ยกเลิก</a>

        </EnableSidebar>
    )
}

export { PublicationEdit }
